module.exports = __webpack_public_path__ + "static/media/comment.1f067f12.png";